<template>
    <CToaster position="top-left">
        <CToast
            v-for="(toast, index) in toasts"
            :key="index"
            :closeButton="true"
            :show="true"
            :fade="false"
        >
            <template v-slot:header>
                <svg
                    class="rounded me-2"
                    width="20"
                    height="20"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid slice"
                    focusable="false"
                    role="img"
                >
                    <rect width="100%" height="100%" :fill="toast.success ? 'rgb(51, 153, 255)' : '#E36049'"></rect>
                </svg><strong class="mr-auto ml-1">{{toast.success ? 'Success' : 'Error'}}</strong>
            </template>
            {{toast.content}}
        </CToast>
    </CToaster>
</template>

<script>
export default {
    props: {
        toasts: Array
    }
}
</script>

<style lang="scss">
.toaster-top-full, .toaster-top-center, .toaster-top-right, .toaster-top-left {
    top: 60px !important;
}
.toast-body {
    color: #3c4b64;
}
</style>